import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AbstractHttpService } from './abstract-http-service';
import {IpopConfiguration} from '../model/ipop-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class IpopConfigurationService extends AbstractHttpService {
  defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  getSettings(accountId: number): Observable<IpopConfiguration> {
    return this.httpClient.get<IpopConfiguration>(
      `//${environment.autoDomain}:${environment.autoPort}/api/ipop-configuration/${accountId}`,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }

  updateSettings(settings: IpopConfiguration): Observable<any> {
    return this.httpClient.put(
      `//${environment.autoDomain}:${environment.autoPort}/api/ipop-configuration`,
      settings,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }
}
